var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7863 1.9249H3.2149C2.50374 1.9249 1.92918 2.49945 1.92918 3.21061V32.782C1.92918 33.4932 2.50374 34.0678 3.2149 34.0678H32.7863C33.4975 34.0678 34.072 33.4932 34.072 32.782V3.21061C34.072 2.49945 33.4975 1.9249 32.7863 1.9249ZM31.5006 31.4963H24.1037V21.6204H28.2823L28.9091 16.7709H24.1037V13.6731C24.1037 12.2669 24.4935 11.3106 26.5064 11.3106H29.0738V6.97133C28.6278 6.91106 27.1051 6.77847 25.3292 6.77847C21.6247 6.77847 19.0895 9.04052 19.0895 13.191V16.7669H14.9028V21.6164H19.0935V31.4963H4.50061V4.49633H31.5006V31.4963Z",
    fill: "#095105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a2d894fc9569799898df73d6c3fb48e1.svg";
export { ForwardRef as ReactComponent };